<script lang="ts" setup>
import { AppCheckbox } from '@libs/ui';

import { FilterType, FilterUpdateEventType } from '../../Filters.model';

import type {
  CheckboxUpdateFilterEvent,
  CheckboxFilterData,
} from './CheckboxFilter.model';

interface FlightsFiltersProps {
  data: CheckboxFilterData;
}

const props = defineProps<FlightsFiltersProps>();

interface CheckboxFilterEmits {
  (eventName: 'update', context: CheckboxUpdateFilterEvent): void;
}

const emit = defineEmits<CheckboxFilterEmits>();

function update(): void {
  emit('update', {
    eventType: FilterUpdateEventType.UpdateFilter,
    filterType: FilterType.Checkbox,
    selected: props.data.options.code,
    ingredientId: props.data.ingredientId,
  });
}
</script>

<template>
  <AppCheckbox
    :theme="props.data.options.type.theme"
    :size="props.data.options.type.size"
    :state="props.data.options.type.isDisabled"
    :checked="props.data.options.checked"
    @change="update"
  >
    {{ props.data.options.label }}
  </AppCheckbox>
</template>
